import { ReactElement, ReactNode } from 'react';

import LocationFeatureSubscriptionsProviderContext from '../contexts/location-feature-subscriptions-provider-context';
import useLocationFeatureSubscriptions from '../hooks/location-feature-subscriptions';

type LocationFeatureSubscriptionsProviderProps = {
  children: ReactNode;
};

const LocationFeatureSubscriptionsProvider = ({ children }: LocationFeatureSubscriptionsProviderProps): ReactElement => (
  <LocationFeatureSubscriptionsProviderContext value={useLocationFeatureSubscriptions()}>
    {children}
  </LocationFeatureSubscriptionsProviderContext>
);

export default LocationFeatureSubscriptionsProvider;
